import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "./baseQuery";
import { worksListBody } from "../app/goals/goalRules";

/**
 * Eser kütüphanesi (mobil /works/list ucu, web de doğrudan kullanıyor).
 * parentId verilmezse kök eserler gelir; search verilirse üst eser
 * filtresi yok sayılır, alt eserler de aranır.
 */
export const workApi = createApi({
  reducerPath: "panelWorks",
  baseQuery: axiosBaseQuery(),
  keepUnusedDataFor: 300,
  endpoints: (builder) => ({
    listWorks: builder.query({
      query: (args) => ({ url: "/api/works/list", method: "POST", data: worksListBody(args) }),
      transformResponse: (res) => res?.data?.works || [],
    }),
  }),
});

export const { useListWorksQuery, useLazyListWorksQuery } = workApi;
